<template>
  <span class="">

    <template v-if="valueComp">
      <span :class="itemClass" v-if="!dateHide">
        {{ dateFormatted }}
      </span>
      <span
          :class="{
          [itemClass]: true,
          'text-weight-bold': timeAccent
        }"
          v-if="!timeHide"
      >
        в {{ timeFormatted }}
      </span>
    </template>
    <span v-else>
      {{ placeholder }}
    </span>

  </span>
</template>

<script setup lang="ts">

import {computed, toRefs} from "vue";
import parseTime from "@/core/util/date/parseTime";
import {DateInputFormat} from "@/core/util/date/types";

const props = withDefaults(defineProps<{
  placeholder?: any,
  gutter?: string,
  itemClass?: string,

  dateFormat?: string,
  dateHide?: boolean,
  dateTodayHide?: boolean,
  dateTodayName?: boolean,
  dateTomorrowName?: boolean,

  timeFormat?: string,
  timeHide?: boolean,
  timeAccent?: boolean,

  value?: any,
  valueFormat?: DateInputFormat,

  valueDate?: any,
  valueDateFormat?: DateInputFormat,

  valueTime?: any,
  valueTimeFormat?: string,
}>(), {
  placeholder: null,

  gutter: 'sm',
  itemClass: '',

  dateFormat: 'DD.MM.YYYY',
  dateHide: false,
  dateTodayHide: false,
  dateTodayName: true,
  dateTomorrowName: true,

  timeFormat: 'HH:mm',
  timeHide: false,
  timeAccent: false,

  value: null,
  valueFormat: 'DD.MM.YYYY HH:mm',

  valueDate: null,
  valueDateFormat: 'DD.MM.YYYY',

  valueTime: null,
  valueTimeFormat: 'HH:mm',
})

const {
  value,
  valueDate,
  dateTodayName,
  dateTomorrowName,
  dateFormat,
  valueTime,
  timeFormat,
  valueFormat,
  valueDateFormat,
  valueTimeFormat
} = toRefs(props)

const valueComp = computed(() => {
  if (value.value) {
    return parseTime(value.value, valueFormat.value, 'dayjs')
  } else if (valueDate.value && valueTime.value) {
    return parseTime(valueDate.value + ' ' + valueTime.value, valueDateFormat.value + ' ' + valueTimeFormat.value, 'dayjs')
  } else if (valueDate.value) {
    return parseTime(valueDate.value, valueDateFormat.value, 'dayjs')
  } else if (valueTime.value) {
    return parseTime(valueTime.value, valueTimeFormat.value, 'dayjs')
  }
})

const dateFormatted = computed(() => {
  if (!value.value && !valueDate.value)
    return;
  const v = valueComp.value!.tz()
  if (dateTodayName.value && v.isToday()) {
    return 'сегодня'
  } else if (dateTomorrowName.value && v.isTomorrow()) {
    return 'завтра'
  } else {
    return v.format(dateFormat.value)
  }
})

const timeFormatted = computed(() => {
  return value.value || valueTime.value ? valueComp.value!.tz().format(timeFormat.value) : null
})


</script>

<style lang="scss" scoped>


</style>
